export const Variables = {
    danger: '#B3261E',
    success: '#006768',
    yellow: '#F4C600',
    gray: '#516274',
    shadow: '0 10px 28px rgba(81, 98, 116, 0.12)',
    shadowSoft: '0 6px 18px rgba(81, 98, 116, 0.1)'
}